import { NO_OPTION, YES_OPTION } from "../constants";
import { getTranslatedMainActivityContextOption, getTranslatedMainActivityContractOption, getTranslatedMainActivityOption, getTranslatedNumHoursOption, getTranslatedNumWorkplacesOption, getTranslatedTypeWorkOption } from "../lists/professional";
import { getTranslatedPhysioPostGradAreaOption } from "../lists/qualification";
import { formatYesNoDropdownLists, getDropdownMultiSelectionSimpleValues, getDropdownMultiSelectionValues } from "../utils/form-data-utils";

export const formatProfessionalDataFormValues = (associate, language="pt") => { 
    if(typeof associate.professionalData.professionalExperience !== 'object' && associate.professionalData.professionalExperience !== null) {
        associate.professionalData.professionalExperience = formatYesNoDropdownLists(associate.professionalData.professionalExperience, language);
    }
    else if (typeof associate.professionalData.professionalExperience  === 'object' && associate.professionalData.professionalExperience !== null) {
        associate.professionalData.professionalExperience = formatYesNoDropdownLists(associate.professionalData.professionalExperience.code === YES_OPTION.code, language);
    }

    if(typeof associate.professionalData.streetType !== 'object' && associate.professionalData.streetType !== null) {
        associate.professionalData.streetType = { name: associate.professionalData.streetTypePlaceholder, code: associate.professionalData.streetType };
    }

    if(typeof associate.professionalData.county !== 'object' && associate.professionalData.county !== null) {
        associate.professionalData.county = { name: associate.professionalData.county, code: associate.professionalData.county };
    }

    if(typeof associate.professionalData.district !== 'object' && associate.professionalData.district !== null) {
        associate.professionalData.district = { name: associate.professionalData.district, code: associate.professionalData.district };
    }

    if(typeof associate.professionalData.mainActivity !== 'object' && associate.professionalData.mainActivity !== null) {
        associate.professionalData.mainActivity = { name: associate.professionalData.mainActivity, code: associate.professionalData.mainActivity };
    }
    else if (typeof associate.professionalData.mainActivity === 'object' && associate.professionalData.mainActivity !== null) {
        associate.professionalData.mainActivity = getTranslatedMainActivityOption(associate.professionalData.mainActivity.code, language);
    }

    if(typeof associate.professionalData.mainActivityContext !== 'object' && associate.professionalData.mainActivityContext !== null) {
        associate.professionalData.mainActivityContext = { name: associate.professionalData.mainActivityContext, code: associate.professionalData.mainActivityContext };
    }
    else if (typeof associate.professionalData.mainActivityContext === 'object' && associate.professionalData.mainActivityContext !== null) {
        associate.professionalData.mainActivityContext = getTranslatedMainActivityContextOption(associate.professionalData.mainActivityContext.code, language);
    }

    if(typeof associate.professionalData.mainActivityContract !== 'object' && associate.professionalData.mainActivityContract !== null) {
        associate.professionalData.mainActivityContract = { name: associate.professionalData.mainActivityContract, code: associate.professionalData.mainActivityContract };
    }
    else if (typeof associate.professionalData.mainActivityContract === 'object' && associate.professionalData.mainActivityContract !== null) {
        associate.professionalData.mainActivityContract = getTranslatedMainActivityContractOption(associate.professionalData.mainActivityContract.code, language);
    }

    if(typeof associate.professionalData.mainActivityArea !== 'object' && associate.professionalData.mainActivityArea !== null) {
        associate.professionalData.mainActivityArea = { name: associate.professionalData.mainActivityArea, code: associate.professionalData.mainActivityArea };
    }
    else if (typeof associate.professionalData.mainActivityArea === 'object' && associate.professionalData.mainActivityArea !== null) {
        associate.professionalData.mainActivityArea = getTranslatedPhysioPostGradAreaOption(associate.professionalData.mainActivityArea.code, language);
    }

    if(typeof associate.professionalData.secondaryActivity !== 'object' && associate.professionalData.secondaryActivity !== null) {
        associate.professionalData.secondaryActivity = formatYesNoDropdownLists(associate.professionalData.secondaryActivity);
    }
    else if (typeof associate.professionalData.secondaryActivity  === 'object' && associate.professionalData.secondaryActivity !== null) {
        associate.professionalData.secondaryActivity = formatYesNoDropdownLists(associate.professionalData.secondaryActivity.code === YES_OPTION.code, language);
    }

    if(typeof associate.professionalData.hasClinicActivity !== 'object' && associate.professionalData.hasClinicActivity !== null) {
        associate.professionalData.hasClinicActivity = formatYesNoDropdownLists(associate.professionalData.hasClinicActivity);
    }
    else if (typeof associate.professionalData.hasClinicActivity  === 'object' && associate.professionalData.hasClinicActivity !== null) {
        associate.professionalData.hasClinicActivity = formatYesNoDropdownLists(associate.professionalData.hasClinicActivity.code === YES_OPTION.code, language);
    }

    if(typeof associate.professionalData.professionalExerciseType !== 'object' && associate.professionalData.professionalExerciseType !== null) {
        associate.professionalData.professionalExerciseType = { name: associate.professionalData.professionalExerciseType, code: associate.professionalData.professionalExerciseType };
    }
    else if (typeof associate.professionalData.professionalExerciseType === 'object' && associate.professionalData.professionalExerciseType !== null) {
        associate.professionalData.professionalExerciseType = getTranslatedTypeWorkOption(associate.professionalData.professionalExerciseType.code, language);
    }

    if(typeof associate.professionalData.weeklyHours !== 'object' && associate.professionalData.weeklyHours !== null) {
        associate.professionalData.weeklyHours = { name: associate.professionalData.weeklyHours, code: associate.professionalData.weeklyHours };
    }
    else if (typeof associate.professionalData.weeklyHours === 'object' && associate.professionalData.weeklyHours !== null) {
        associate.professionalData.weeklyHours = getTranslatedNumHoursOption(associate.professionalData.weeklyHours.code, language);
    }

    if(typeof associate.professionalData.workplacesNumber !== 'object' && associate.professionalData.workplacesNumber !== null) {
        associate.professionalData.workplacesNumber = { name: associate.professionalData.workplacesNumber, code: associate.professionalData.workplacesNumber };
    }
    else if (typeof associate.professionalData.workplacesNumber === 'object' && associate.professionalData.workplacesNumber !== null) {
        associate.professionalData.workplacesNumber = getTranslatedNumWorkplacesOption(associate.professionalData.workplacesNumber.code, language);
    }

    if(associate.professionalData.secondaryActivityContext !== null) {
        let activities = Array.isArray(associate.professionalData.secondaryActivityContext) ? associate.professionalData.secondaryActivityContext : associate.professionalData.secondaryActivityContext.split(',');
        
        associate.professionalData.secondaryActivityContext = [];

        for (let i = 0; i < activities.length; i++) {
            associate.professionalData.secondaryActivityContext.push(activities[i]);  // { code: activities[i], name: activities[i] }
        }
    }

    const CA_PROPS = [
        'cardioRespiratory', 'muscleHealth', 'muscleAmputees', 'muscleTMJ',
        'neuroHealth', 'neuroVestibular', 'dermaHealth', 'mentalHealth',
        'womensHealth', 'pelvicHealth', 'sportsHealth', 'oncology',
        'palliativeCare', 'occupational', 'emergencyDisaster', 'animalHealth',
        'publicHealth', 'communityHealth', 'schoolHealth', 'pediatrics',
        'gerontology', 'pain', 'intensiveCare', 'healthProtection'
    ];

    if(associate.professionalData.clinicActivity !== null) {
        const src = associate.professionalData.clinicActivity;
        CA_PROPS.forEach(prop => {
            const key = `${prop}Activities`;
            const rawValues = src[key] === null ? []
                : Array.isArray(src[key]) ? src[key]
                : (src[prop] ? src[prop].split(',') : []);
            associate.professionalData.clinicActivity[key] = rawValues.map(v => ({ name: v, code: v }));
        });
    }
    else {
        associate.professionalData.clinicActivity = {};
        CA_PROPS.forEach(prop => {
            associate.professionalData.clinicActivity[`${prop}Activities`] = [];
        });
    }

    return associate;
}

export const formatProfessionalDataToService = (associate) => { 

    associate.professionalData.professionalExperience = (associate.professionalData.professionalExperience.code === YES_OPTION.code);
    associate.professionalData.streetType = (associate.professionalData.streetType !== null) ? associate.professionalData.streetType.code : null;
    associate.professionalData.county = associate.professionalData.county.code;
    associate.professionalData.district = associate.professionalData.district.code;
    associate.professionalData.mainActivity = (associate.professionalData.professionalExperience.code === YES_OPTION.code) ? associate.professionalData.mainActivity.code : null;
    associate.professionalData.mainActivityContext = (associate.professionalData.professionalExperience.code === YES_OPTION.code) ? associate.professionalData.mainActivityContext.code : null;
    associate.professionalData.mainActivityContract = (associate.professionalData.professionalExperience.code === YES_OPTION.code) ? associate.professionalData.mainActivityContract.code : null;
    associate.professionalData.mainActivityArea = (associate.professionalData.professionalExperience.code === YES_OPTION.code) ? associate.professionalData.mainActivityArea.code : null;
    associate.professionalData.secondaryActivity = (associate.professionalData.secondaryActivity.code === YES_OPTION.code);
    associate.professionalData.professionalExerciseType = (associate.professionalData.professionalExperience.code === YES_OPTION.code) ? associate.professionalData.professionalExerciseType.code : null;
    associate.professionalData.weeklyHours = (associate.professionalData.professionalExperience.code === YES_OPTION.code) ? associate.professionalData.weeklyHours.code : null;
    associate.professionalData.workplacesNumber = (associate.professionalData.professionalExperience.code === YES_OPTION.code) ? associate.professionalData.workplacesNumber.code : null;
    associate.professionalData.secondaryActivityContext = (associate.professionalData.secondaryActivity === true) ? getDropdownMultiSelectionSimpleValues(associate.professionalData.secondaryActivityContext) : null;
    associate.professionalData.hasClinicActivity = (associate.professionalData.hasClinicActivity.code === YES_OPTION.code);
    if(associate.professionalData.hasClinicActivity.code !== NO_OPTION.code) {
        const CA_PROPS = [
            'cardioRespiratory', 'muscleHealth', 'muscleAmputees', 'muscleTMJ',
            'neuroHealth', 'neuroVestibular', 'dermaHealth', 'mentalHealth',
            'womensHealth', 'pelvicHealth', 'sportsHealth', 'oncology',
            'palliativeCare', 'occupational', 'emergencyDisaster', 'animalHealth',
            'publicHealth', 'communityHealth', 'schoolHealth', 'pediatrics',
            'gerontology', 'pain', 'intensiveCare', 'healthProtection'
        ];
        CA_PROPS.forEach(prop => {
            associate.professionalData.clinicActivity[prop] = getDropdownMultiSelectionValues(associate.professionalData.clinicActivity[`${prop}Activities`]);
        });
    }

    return associate;
}